import React, { useState } from 'react';
import './experience.css';
import { FiArrowUpRight, FiMapPin, FiUsers } from 'react-icons/fi';
import { experiences, leadership } from '../../data/experience';

const Experience = () => {
  const [activeId, setActiveId] = useState(experiences[0].id);
  const active = experiences.find((item) => item.id === activeId) || experiences[0];

  return (
    <section id="experience">
      <div className="container">
        <div className="section__head reveal">
          <span className="section__eyebrow">03 — Experience</span>
          <div className="section__title">
            <h2>Where I&apos;ve shipped</h2>
          </div>
          <p className="section__lead">
            From Android in 2018 to AI platforms today — across fintech, EV infrastructure,
            media and mobile. Leading architecture from Addis Ababa while building for teams in
            San Francisco, New York, London, Toronto and Ibadan.
          </p>
        </div>

        <div className="xp__layout reveal">
          <div className="xp__tabs" role="tablist" aria-label="Companies">
            {experiences.map((item) => (
              <button
                key={item.id}
                type="button"
                role="tab"
                id={`xp-tab-${item.id}`}
                aria-selected={activeId === item.id}
                aria-controls={`xp-panel-${item.id}`}
                className={`xp__tab ${activeId === item.id ? 'is-active' : ''}`}
                onClick={() => setActiveId(item.id)}
              >
                <span className="xp__tab-company">
                  {item.short}
                  {item.current && <span className="xp__live" aria-label="Current role" />}
                </span>
                <span className="xp__tab-period mono">{item.period}</span>
              </button>
            ))}
          </div>

          <article
            className="xp__panel"
            role="tabpanel"
            id={`xp-panel-${active.id}`}
            aria-labelledby={`xp-tab-${active.id}`}
            key={active.id}
          >
            <header className="xp__panel-head">
              <h3>
                {active.role}
                <span className="xp__at"> @ {active.company}</span>
              </h3>

              <div className="xp__panel-meta mono">
                <span>{active.period}</span>
                <span className="xp__sep">/</span>
                <span className="xp__location">
                  <FiMapPin />
                  {active.location}
                </span>
                <span className="xp__sep">/</span>
                <span className="xp__type">{active.type}</span>
              </div>

              <p className="xp__summary">{active.summary}</p>

              <ul className="xp__stack">
                {active.stack.map((tech) => (
                  <li key={tech} className="tag">
                    {tech}
                  </li>
                ))}
              </ul>
            </header>

            <ul className="xp__points">
              {active.points.map((point) => (
                <li key={point}>
                  <FiArrowUpRight className="xp__point-icon" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </article>
        </div>

        <div className="xp__leadership reveal">
          <div className="xp__leadership-head">
            <span className="xp__leadership-icon">
              <FiUsers />
            </span>
            <div>
              <h3>Leadership &amp; engineering practice</h3>
              <p>What I take on regardless of which company&apos;s logo is on the repo.</p>
            </div>
          </div>

          <ul className="xp__leadership-list">
            {leadership.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Experience;
